var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIncorrect({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12.17 12.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fe0000;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.85,1.84c.21-.21.32-.46.32-.76,0-.3-.1-.55-.32-.77-.21-.21-.46-.31-.76-.32-.3,0-.55.11-.77.32l-4.24,4.24L1.84.32C1.64.11,1.38,0,1.08,0c-.3,0-.55.11-.77.32C.11.53,0,.79,0,1.08c0,.3.11.55.32.76l4.24,4.24L.32,10.32c-.21.21-.31.47-.32.77,0,.3.11.55.32.76.21.21.47.32.77.32.3,0,.55-.1.76-.32l4.24-4.24,4.24,4.24c.21.21.47.32.77.32.3,0,.55-.1.76-.32.21-.21.32-.46.32-.76,0-.3-.1-.55-.32-.77l-4.24-4.24L11.85,1.84Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/Incorrect.5826cfce2f2c6daac95e6f0212217b92.svg";
export { ForwardRef as ReactComponent };